import { LitElement, html, svg } from 'lit';

export class IconLayers16 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><title>Tre kvadrater som flyter inn i hverandre</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m1 8 7 3 7-3M8 1 1 4l7 3 7-3-7-3ZM1 12l7 3 7-3"></path></svg>`; }
}
if (!customElements.get('f-icon-layers16', IconLayers16)) {
  customElements.define('f-icon-layers16', IconLayers16);
}